import React from 'react';

import Sidebar from 'shared/components/navigation/sidenav';
import TopHeader from 'shared/components/navigation/topHeader';
import { WINDOW_WIDTH } from 'shared/constants/constants';
// import Footer from 'shared/components/footer/footer';

const Layout: React.FC = (props) => {
	return (
		<div id="wrapper">
			<Sidebar />
			<div id="page-wrapper" className="gray-bg">
				{WINDOW_WIDTH > 640 && <TopHeader />}
				{/* {WINDOW_WIDTH <= 640 && <MobileTopHeader />} */}
				{props.children}
			</div>
			{/* <Footer /> */}
		</div>
	);
};

export default Layout;
